import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="18"
    height="22"
    viewBox="0 0 18 22"
    stroke="currentColor"
    fill="transparent"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M5.75008 16.4167V14.25M9.00008 16.4167V12.0833M12.2501 16.4167V9.91667M14.4167 20.75H3.58341C2.3868 20.75 1.41675 19.78 1.41675 18.5833V3.41667C1.41675 2.22005 2.3868 1.25 3.58341 1.25H9.63468C9.922 1.25 10.1976 1.36414 10.4007 1.5673L16.2661 7.4327C16.4693 7.63586 16.5834 7.91141 16.5834 8.19873V18.5833C16.5834 19.7799 15.6134 20.75 14.4167 20.75Z" />
  </svg>
);
